import React, { useState } from "react";
import { ButtonFilled } from "./UIButtons";
const VerifyFingerprintComponent = ({ fingerprintData, onVerified }) => {
  const [status, setStatus] = useState("");
  const verifyFingerprint = async () => {
    setStatus("Verifying...");
    try {
      const challenge = new Uint8Array(32);
      window.crypto.getRandomValues(challenge);
      const publicKey = {
        challenge,
        timeout: 60000,
        allowCredentials: [
          {
            id: Uint8Array.from(atob(fingerprintData?.rawId), (c) =>
              c.charCodeAt(0)
            ),
            type: "public-key",
            transports: ["internal"],
          },
        ],
        userVerification: "required",
      };
      const assertion = await navigator.credentials.get({ publicKey });
      if (assertion) {
        setStatus(":white_check_mark: Verified");
        onVerified(); // ← This triggers API + closes modal
      } else {
        setStatus(":x: Verification failed");
      }
    } catch (err) {
      console.error(":x: Fingerprint error:", err);
      setStatus(":x: Error: " + err.message);
    }
  };
  return (
    <div>
      <ButtonFilled onClick={verifyFingerprint}>Verify Now</ButtonFilled>
      <p>{status}</p>
    </div>
  );
};
export default VerifyFingerprintComponent;
